{
    "actions": {
        "row": {
            "emergency_collect": "TLC de secours",
            "terminate_payludd": "Résiliation Payludd"
        }
    },
    "filter": {
        "placeholder": {
            "label_merchant": "Filtrer par libellé marchand",
            "email_merchant": "Filtrer par email marchand",
            "manufacturer": "Filtrer par constructeur",
            "model": "Filtrer par modèle",
            "organization": "Filtrer par organisation",
            "pos_label": "Filtrer par libellé TPE",
            "package_label": "Filtrer par personnalisation",
            "package_code": "Filtrer par code init.",
            "provider_legal_name": "Filtrer par fournisseur direct",
            "serial_number": "Filtrer par série #",
            "version_pax": "Filtrer par version du Pax",
            "version_payludd": "Filtrer par version de Payludd",
            "version_android": "Filtrer par version d'Android"
        }
    },
    "keys": {
        "download_date": "Date télécharg.t",
        "email_merchant": "Email marchand",
        "label_merchant": "Libellé marchand",
        "last_connection_date": "Connecté le",
        "manufacturer": "Constr.",
        "model": "Modèle",
        "organization": "Organisation",
        "pos_label": "Libellé TPE",
        "package_label": "Personnalisation",
        "package_code": "Code init.",
        "package_initialization_status": "Statut init.",
        "provider_legal_name": "Fournisseur direct",
        "serial_number": "Série #",
        "subscriptions_status": "Abo. passerelle",
        "end_billing_date": "Résiliation Payludd",
        "version_pax": "V. Pax",
        "version_payludd": "V. Payludd",
        "version_android": "V. Android",
        "contract": {
            "profiles": {
                "application": "Application",
                "number": "Numéro",
                "bank_code": "Code banque",
                "rank": "Rang",
                "label": "Libellé"
            }
        }
    },
    "modal": {
        "terminate_payludd": {
            "title": "Résiliation Payludd",
            "text_common": "Êtes-vous certain de vouloir résilier le service Payludd ?",
            "text_before_1_33_0": "Les appels de l'application Payludd ne seront plus traités et le service Payludd ne sera plus opérationnel.\n\nIl est recommandé de réinitialiser manuellement l'application dans le menu Paramètres de l'application via le bouton \"Remise à zéro\".",
            "text_from_1_33_0": "En cas de résiliation, l'application Payludd sera remise à zéro automatiquement lors de son prochain appel.",
            "success": "L'abonnement Payludd a été résilié avec succès.",
            "error": "Une erreur est survenue lors de la résiliation de l'abonnement Payludd."
        },
        "emergency_remote_collection": {
            "title": "TLC de secours",
            "warning": {
                "subtitle": "Message important",
                "row1": "La télécollecte de secours ne doit être utilisée qu'en cas de défaillance du matériel et d'impossibilité de faire les télécollectes en local.",
                "row2": "Voulez-vous continuer la télécollecte de secours ?",
                "row3": "Attention le lancement de la télécollecte de secours va déclencher le blocage du terminal sur la passerelle afin d'éviter que les transactions soient remisées deux fois."
            },
            "contract_selection": {
                "instruction": "Sélectionnez le contrat VAD pour le marchand {{label}}",
                "error": "Uniquement les terminaux PAX avec la solution Payludd et une personnalisation appliquée peuvent lancer une télécollecte de secours.",
                "redirect": "Vous n’avez pas de contrat VAD, merci d’en créer un en cliquant ici."
            },
            "remote_collections_selection": {
                "subtitle": "Sélection des remises"
            },
            "summarize": {
                "warning": "Les transactions qui ont été refusées ne seront pas envoyées lors de la télécollecte de secours.",
                "table": {
                    "col1": "Contrat Rang",
                    "col2": "Nombre débit",
                    "col3": "Montant débit",
                    "col4": "Nombre crédit",
                    "col5": "Montant crédit",
                    "col6": "Nombre annulation",
                    "col7": "Montant annulation",
                    "col8": "Montant total"
                },
                "total": "Total :"
            },
            "steps": {
                "warning": "Étape {{step}} sur {{maxStep}}: Avertissement",
                "contract_selection": "Étape {{step}} sur {{maxStep}}: Sélection du contrat VAD",
                "remote_collections_selection": "Étape {{step}} sur {{maxStep}}: Sélection des remises",
                "summarize": "Étape {{step}} sur {{maxStep}}: Récapitulatif des transactions pour la télécollecte de secours"
            },
            "success": "La télécollecte de secours a été lancée avec succès. Attention, cette opération peut prendre quelques minutes.",
            "error": "Une erreur est survenue lors du lancement de la télécollecte de secours."
        }
    },
    "status": {
        "TO_BE_ACTIVATED": "En attente",
        "ACTIVATED": "Activé",
        "TERMINATED": "Résilié",
        "IN_STOCK": "En stock"
    },
    "status_init": {
        "INIT_OK": "Réussi",
        "INIT_KO": "Échec",
        "PASSERELLE_PRELUDD_KO": "Échec passerelle",
        "VERSION_APP_PAX_KO": "Échec version Pax",
        "TELECHARGEMENT_KO": "Échec téléchargement",
        "PACKAGE_CHARGEMENT_KO": "Échec package",
        "KO_PAS_DE_BENEFICIAIRE": "Échec bénéficiaires",
        "WEBAPP_TELECHARGEMENT_KO": "Échec application",
        "CONTRAT_KO": "Échec contrat",
        "TLP_KO": "Échec téléparamétrage"
    },
    "tooltip": {
        "subscriptions_tab": "Cet onglet contient les terminaux ayant récupéré une personnalisation Payludd."
    }
}